import { copilotToolConfigs } from "@buildwithflux/models";
export function markdownLeadBoldToInline(markdown) {
    if (!markdown)
        return "";
    const s = markdown.replace(/[\r\n]+/g, " ").trim();
    const m = s.match(/^\s*\*\*(.+?)\*\*\s*(.*)$/);
    if (!m)
        return s;
    const title = m[1]?.trim();
    const rest = m[2]?.trim();
    const needsColon = !title?.endsWith(":");
    if (!rest) {
        if (title) {
            return needsColon ? `${title}:` : title;
        }
        return markdown;
    }
    return `${needsColon ? `${title}:` : title} ${rest}`;
}
export function humanizeThought(thought, showReasoning = false) {
    try {
        if (thought.event === "invoke" || thought.event === "invoke_tool") {
            const toolKey = thought.origin;
            switch (thought.origin) {
                case "library": {
                    if (thought.payload.queries?.length === 1) {
                        return `Starting 1 component search`;
                    }
                    return `Starting ${thought.payload.queries?.length} component searches`;
                }
                case "web": {
                    return `Searching web for: "${thought.payload.query}"`;
                }
                case "action": {
                    return "Checking if I can make the changes for you...";
                }
                case "help": {
                    return `Reading docs for: "${thought.payload.vectorQuery}"`;
                }
                case "simulator": {
                    return `Analyze ${thought.payload.simulationRequests?.length} simulation request(s)...`;
                }
            }
            return `Using ${copilotToolConfigs[toolKey]?.name} Tool...`;
        }
        else if (showReasoning && thought.event === "reasoning_summary") {
            const processedText = markdownLeadBoldToInline(thought.payload.reasoningText);
            const colonIndex = processedText.indexOf(":");
            let result = colonIndex !== -1 ? processedText.substring(0, colonIndex) : processedText;
            const trailingPeriods = result.match(/\.+$/);
            const currentPeriodCount = trailingPeriods ? trailingPeriods[0].length : 0;
            if (currentPeriodCount < 3) {
                result = result + ".".repeat(3 - currentPeriodCount);
            }
            else if (currentPeriodCount > 3) {
                result = result.replace(/\.+$/, "...");
            }
            return result;
        }
        switch (thought.origin) {
            case "library": {
                switch (thought.event) {
                    case "plan_and_solve_mode":
                        return `Dispatching Library tool to find: "${thought.payload.query}"`;
                    case "create_plan":
                        return `Creating search plan for: "${thought.payload.inputQuery}"`;
                    case "execute_hybrid_search":
                        return `Searching: "${thought.payload.query}"`;
                    case "executed_plan":
                        return `Found ${thought.payload.resultCount} results.`;
                    case "replan":
                        return `Searching: "${thought.payload.inputQuery}"`;
                    case "completed":
                        if (thought.payload.queries?.length === 1) {
                            return `Completed 1 component search.`;
                        }
                        return `Completed ${thought.payload.queries?.length} component searches.`;
                }
                break;
            }
            case "web": {
                switch (thought.event) {
                    case "completed_web_search":
                        return `Found ${thought.payload.resultCount} results.`;
                }
                break;
            }
            case "file": {
                switch (thought.event) {
                    case "execute_file_query":
                        const fileName = thought.payload.sourceUrl.split("/").pop() ?? thought.payload.sourceUrl;
                        return `Looking for "${thought.payload.query}" in ${fileName}`;
                }
                break;
            }
            case "autopilot": {
                switch (thought.event) {
                    case "execution_step_started":
                        return `Started: ${thought.payload.content}`;
                    case "stop_requested":
                        return `Stopping: ${thought.payload.content}`;
                    default:
                        return thought.payload.content;
                }
            }
            case "simulator": {
                switch (thought.event) {
                    case "execute_step":
                        return `Running Simulator...`;
                    case "created_plan":
                        return thought.payload.reasoning_summary;
                    case "evaluate_results":
                        return `Evaluating Results...`;
                    case "plan_another_run":
                        return thought.payload.reasoning_summary;
                    case "finished":
                        return thought.payload.reasoning_summary;
                    case "inconclusive":
                        return thought.payload.reasoning_summary;
                }
            }
        }
    }
    catch (_error) {
        // ignore
    }
    return undefined;
}
//# sourceMappingURL=thoughts.js.map